import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { MUTATION_KEY } from './keys';
import { clmUserApiClient } from '../clients';
import type {
  ApiErrorResponse,
  PatientSearchVerifyRequest,
  PatientSearchVerifyResponse,
} from '../types';
import { isApiErrorResponse } from '../utils';

const patientSearchVerifyMutation = async (
  data: PatientSearchVerifyRequest,
): Promise<PatientSearchVerifyResponse> => {
  const response = await clmUserApiClient.post<
    PatientSearchVerifyResponse,
    ApiErrorResponse
  >('patient/retrieve', data);

  if (!response.data) {
    throw new Error('No data returned from patient search verify');
  }

  if (!response.ok) {
    if (isApiErrorResponse(response.data)) {
      throw new Error(response.data.details);
    }
    throw new Error('Unknown error');
  }

  return response.data;
};

export const usePatientSearchVerifyMutation = (
  config?: Omit<
    UseMutationOptions<
      PatientSearchVerifyResponse,
      Error,
      PatientSearchVerifyRequest
    >,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation({
    mutationKey: [MUTATION_KEY.PATIENT_SEARCH_VERIFY],
    mutationFn: patientSearchVerifyMutation,
    ...config,
  });
